import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { phonePatientSac } from '@/utils/consts/sac.consts';
import { Link } from '@/components/ui/link/link.component';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaqAssistedShoppingButton = () => {
  const { buttonSmFit } = styleFaq();
  const { url } = useWhatsappLinkWithAnalytics(
    phonePatientSac,
    patientSacWhatsappMessage,
  );

  return (
    <Button
      asChild
      className={buttonSmFit()}
      startIcon={faWhatsapp}
      variant="secondary"
    >
      <Link
        prefetch={false}
        href={url}
        target="_blank"
        data-testid={DataTestIdEnum.FAQ_ASSISTED_SHOPPING_BUTTON}
        data-analytics-event={AnalyticsEnum.CLICK_FAQ_WHATSAPP_SAC_BUTTON}
      >
        WhatsApp do SAC
      </Link>
    </Button>
  );
};
